import { CONTACT_EMAIL } from "../lib/contact";

const ITEMS: Array<{ q: string; a: string }> = [
  {
    q: "Is my data safe — can I get everything back later?",
    a: "Yes. Everything you enter is stored carefully and is never lost. You can retrieve it at any time, at any level of detail — from the complete canvas (every answer, plus a machine-readable JSON export) down to the last field, all the way up to higher-level summaries built from it: a signed governance report and a board-ready executive one-pager. Time spent entering your answers is never wasted — it's always there when you need it.",
  },
  {
    q: "What does \"data contribution\" actually share?",
    a: "Only structured data — your overall grade, per-layer scores, deployment-stage tag, gap category codes. Never your answers, never your workflow name, never the named owner. The pool is audited to ensure no free-text ever lands in it.",
  },
  {
    q: "How long does a canvas take?",
    a: "A focused 45-minute session for a small system. Larger or higher-stakes systems take longer — the coach won't let you skim. You can pause and resume any time; nothing is lost.",
  },
  {
    q: "Can I cancel my paid plan?",
    a: "Yes. When your plan ends you keep access to your last active session; new sessions, coaching, and reminders stop at the end of the billing period. Before then you can download all your content — governance reports, baseline records, and canvas data — to keep your own permanent copy.",
  },
  {
    q: "I lost my invite code, can I still sign up?",
    a: `Email us at ${CONTACT_EMAIL} and we'll send a fresh one if you're on the list. Without a code, the gate stays closed during the private beta.`,
  },
];

export function Faq() {
  return (
    <section id="data-handling" className="lp-faq" aria-labelledby="faq-heading">
      <h2 className="lp-faq__heading" id="faq-heading">
        Questions
      </h2>
      <div className="lp-faq__list">
        {ITEMS.map((item) => (
          <details key={item.q} className="lp-faq__item">
            <summary className="lp-faq__q">{item.q}</summary>
            <p className="lp-faq__a">{item.a}</p>
          </details>
        ))}
      </div>
    </section>
  );
}
